import {Pipe, PipeTransform} from '@angular/core';

import {LocalisationService} from '../services/localisation.service';

@Pipe({
    name: 'localise'
})

export class LocalisationPipe implements PipeTransform {
    constructor(
        private readonly localisationService: LocalisationService
    ) {
    }

    transform(languageDictionaryKey: string): string {
        return this.localisationService.languageDictionary[languageDictionaryKey];
    }
}
